import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { inject, Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AuthService } from "../../auth.service";
import { EnvService } from "@gea-waldviertler-website/shop-lib";

@Injectable()
export class HttpAuthInterceptor implements HttpInterceptor {
  authService: AuthService

  private envService = inject(EnvService)


  constructor(
    @Inject(AuthService) authService: AuthService
  ) {
    this.authService = authService
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // add auth header on gea-api requests only
    if (! (request.url.startsWith(this.envService.config.apiURL) || (request.url.startsWith(this.envService.config.apiURL_SSR)))) return next.handle(request)

    if (request.headers.get('Authorization')) {
      return next.handle(request)
    }

    const user = this.authService.user()
    if (user) {
      const req = request.clone({
        headers: request.headers.set('Authorization', 'Bearer ' + user.authToken)
      });
      return next.handle(req)
    }

    return next.handle(request)
  }
}
